module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a8-8-7965e8dc1f2e090e776fa6f4064e0000.jpg";